// 2P AI — indicatore della striscia di riepilogo (§8.1). `alert` evidenzia il valore in accento.
import type { ReactNode } from 'react';
import { Icon } from './Icon';

export function Gauge({ icon, label, value, foot, alert }: { icon: string; label: string; value: ReactNode; foot?: ReactNode; alert?: boolean }) {
  return (
    <div className={alert ? 'gauge alert' : 'gauge'}>
      <div className="lbl"><Icon name={icon} />{label}</div>
      <div className="val">{value}</div>
      {foot != null ? <div className="foot">{foot}</div> : null}
    </div>
  );
}
